/*
 ** 署名付きURLを使用したオブジェクトのアップロードのモック
 */
import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

const response = {};

export const commonPresignedUrlPut = http.put(
  createMockEndpoint('/presigned-url'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
